import React from "react";
import { useStateContext } from "../../../context/ContextProvider";
import { renderText, truncateText } from "../../hooks/TextVeiw";
import { Link } from "react-router-dom";
import { IoIosArrowForward, IoIosArrowBack } from "../../icons";
import { useTranslation } from "react-i18next";
const C_BlogCard = ({ card }) => {
  const { currentLang } = useStateContext();
  const isAr = currentLang === "ar";
  const desc = isAr ? card.description_Ar : card.description_En;
  const { t } = useTranslation();
  return (
    <div className="bg-light-secondary dark:bg-dark-secondary border border-light-strock rounded-xl overflow-hidden flex flex-col ">
      <div className="max-h-[300px] w-full overflow-hidden rounded-t-xl mb-2 ">
        <img src={card.image} className="w-full" />
      </div>
      <div className="flex flex-col items-start gap-2 p-5">
        <p className="caption text-light-caption dark:text-dark-caption">
          {card.date}
        </p>

        <div className="flex flex-col items-start  h-[12rem] max-h-[12rem] overflow-hidden">
          <h5 className="h6 mb-2 text-light-title dark:text-dark-title">
            {isAr ? card.title_Ar : card.title_En}
          </h5>
          <p className="body-2 text-light-subtitle  dark:text-dark-subtitle">
            {truncateText(desc, 45)}
          </p>
        </div>

        <Link
          to={`/BlogDetails_page/${card.id}`}
          state={{ blogData: card }}
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <button
            className=" transition delay-150 duration-300 ease-in-out ltr:hover:translate-x-4 rtl:hover:-translate-x-4 hover:scale-110
          text-light-link dark:text-dark-link flex flex-row items-center mt-4 text-sm font-kufi gap-2 "
          >
            <span> {t("Reade more")}</span>
            <span>
              {" "}
              {isAr ? (
                <IoIosArrowBack size={18} />
              ) : (
                <IoIosArrowForward size={18} />
              )}
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default C_BlogCard;
